import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Vertikale Feldgruppe (MUI-`FormControl`-Ersatz): Label + Control + Helper. */
export const FormControl = forwardRef(function FormControl({ error, className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('sec-form-control', error && 'sec-form-control--error', className), ...rest });
});
